module.exports = __webpack_public_path__ + "img/bg-bubble-two.7fec34fc.png";